import Headings from '@/components/Editor/Form/fields/Headings';
import Animation from '@/components/Editor/Form/fields/Animation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WidgetEditFormTreeMapFields = _ref => {
  let {
    widgetId,
    sectionId,
    config,
    onChange
  } = _ref;
  const nameSpace = `tree-map-${widgetId}-${sectionId}`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Headings, {
      nameSpace: nameSpace,
      widgetId: widgetId,
      sectionId: sectionId,
      hasHeading: config.hasHeading,
      title: config.title,
      onChange: updates => onChange('', updates)
    }), /*#__PURE__*/_jsx(Animation, {
      nameSpace: nameSpace,
      animation: config.animation,
      defaults: {
        duration: 1000,
        delay: 0
      },
      onChange: update => onChange('animation', update)
    })]
  });
};

export default WidgetEditFormTreeMapFields;